// Plain-HTTP origins other than localhost (e.g. the dashboard opened at http://192.168.x.x:5173
// from another device on the LAN) are not "secure contexts": browsers hide crypto.randomUUID and
// navigator.clipboard there. These helpers fall back to APIs that work everywhere.

type CryptoLike = Pick<Crypto, 'getRandomValues'> & { randomUUID?: () => string };

/** A UUID v4 for the x-correlation-id header. */
export function correlationId(c: CryptoLike = crypto): string {
  if (typeof c.randomUUID === 'function') return c.randomUUID();
  const b = c.getRandomValues(new Uint8Array(16));
  b[6] = (b[6]! & 0x0f) | 0x40; // version 4
  b[8] = (b[8]! & 0x3f) | 0x80; // RFC 4122 variant
  const h = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

export async function copyText(text: string): Promise<void> {
  if (window.isSecureContext && navigator.clipboard) return navigator.clipboard.writeText(text);
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  // Inside a dialog or sheet, the focus trap would pull focus out of a textarea added to <body>.
  (document.activeElement?.closest('[role="dialog"]') ?? document.body).appendChild(ta);
  ta.select();
  try {
    if (!document.execCommand('copy')) throw new Error('Copy failed');
  } finally {
    ta.remove();
  }
}
